module.exports = {};
module.exports.specialCaracters = [
  ['à', '&agrave;', 'agrave'],
  ['À', '&Agrave;', 'agrave'],
  ['á', '&aacute;', 'aacute'],
  ['Á', '&Aacute;', 'aacute'],
  ['â', '&acirc;', 'acirc'],
  ['Â', '&Acirc;', 'acirc'],
  ['ã', '&atilde;', 'atilde'],
  ['Ã', '&Atilde;', 'atilde'],
  ['ä', '&auml;', 'auml'],
  ['Ä', '&Auml;', 'auml'],
  ['å', '&aring;', 'aring'],
  ['Å', '&Aring;', 'aring'],
  ['æ', '&aelig;', 'aelig'],
  ['Æ', '&AElig;', 'aelig'],
  ['è', '&egrave;', 'egrave'],
  ['È', '&Egrave;', 'egrave'],
  ['é', '&eacute;', 'eacute'],
  ['É', '&Eacute;', 'eacute'],
  ['ê', '&ecirc;', 'ecirc'],
  ['Ê', '&Ecirc;', 'ecirc'],
  ['ë', '&euml;', 'euml'],
  ['Ë', '&Euml;', 'euml'],
  ['ì', '&igrave;', 'igrave'],
  ['Ì', '&Igrave;', 'igrave'],
  ['í', '&iacute;', 'iacute'],
  ['Í', '&Iacute;', 'iacute'],
  ['î', '&icirc;', 'icirc'],
  ['Î', '&Icirc;', 'icirc'],
  ['ï', '&iuml;', 'iuml'],
  ['Ï', '&Iuml;', 'iuml'],
  ['ò', '&ograve;', 'ograve'],
  ['Ò', '&Ograve;', 'ograve'],
  ['ó', '&oacute;', 'oacute'],
  ['Ó', '&Oacute;', 'oacute'],
  ['ô', '&ocirc;', 'ocirc'],
  ['Ô', '&Ocirc;', 'ocirc'],
  ['õ', '&otilde;', 'otilde'],
  ['Õ', '&Otilde;', 'otilde'],
  ['ö', '&ouml;', 'ouml'],
  ['Ö', '&Ouml;', 'ouml'],
  ['ø', '&oslash;', 'oslash'],
  ['Ø', '&Oslash;', 'oslash'],
  ['ù', '&ugrave;', 'ugrave'],
  ['Ù', '&Ugrave;', 'ugrave'],
  ['ú', '&uacute;', 'uacute'],
  ['Ú', '&Uacute;', 'uacute'],
  ['û', '&ucirc;', 'ucirc'],
  ['Û', '&Ucirc;', 'ucirc'],
  ['ü', '&uuml;', 'uuml'],
  ['Ü', '&Uuml;', 'uuml'],
  ['ñ', '&ntilde;', 'ntilde'],
  ['Ñ', '&Ntilde;', 'ntilde'],
  ['ç', '&ccedil;', 'ccedil'],
  ['Ç', '&Ccedil;', 'ccedil'],
  ['ý', '&yacute;', 'yacute'],
  ['Ý', '&Yacute;', 'yacute'],
  ['ß', '&szlig;', 'szlig'],
  ['«', '&laquo;'],
  ['»', '&raquo;'],
  ['&', '&amp;'],
  ['<', '&lt;'],
  ['>', '&gt;'],
  ['"', '&quot;'],
  ['§', '&para;'],
  ['©', '&copy;'],
];
